import React from 'react'

import template from './cta-3.twig'

import parse from 'html-react-parser'

import {
  Asset,
  ButtonOptions,
  ContentOptions,
  GridOptions,
  HeadlineOptions,
  LabelOptions,
  LinkOptions,
  ListOptions,
  Offset,
  VideoOptions,
} from '@miro-site/components_utils'

type Cta3Info = {
  label?: LabelOptions
  headline?: HeadlineOptions
  content?: ContentOptions
  list?: ListOptions
  link?: LinkOptions
  button?: ButtonOptions
}

export interface Cta3Props {
  offset?: Offset
  headline?: HeadlineOptions
  content?: ContentOptions
  grid?: GridOptions
  image?: Asset
  video?: VideoOptions
  info: Cta3Info
  children?: React.ReactNode
}

const Cta3 = (props: Cta3Props): React.ReactElement => {
  return (
    <>
      {parse(
        template({
          ...props,
          component_name: 'CTA Section',
          ctf_assets: 'images.ctfassets.net',
        }),
      )}
    </>
  )
}

export default Cta3
